module.exports = "/static/assets/7e9fd4a23990a7a8f94c59c2671ecd62.png";